export const informes = [
    {
        "titulo" : "Programa Anual de Evaluación para el Desarrollo del Estado de Hidalgo",
        "descripcion" : "",
        "trimestres" : [
            {
                 "trimestre" : "2026",
                 "url" : "../../PAED/PAED2026.pdf"
             },

        ]
    },
    {
        "titulo" : "Reporte Gráfico Estado de Hidalgo",
        "descripcion" : "",
        "trimestres" : [
            {
                "trimestre" : "Previo 3er Informe",
                "url" : "../../Reportes/RGEH-Previo3erInforme2025.pdf"
            },
            {
                "trimestre" : "Post 3er Informe",
                "url" : ".../../Reportes/RGEH-Post3erInforme2025.pdf"
            }
            
        ]
    
    }
]